import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'lodash';
import Marionette from 'backbone.marionette';
import '@core/vendor/radio.shim'; // shim app.channel
// import Example from './src/black-friday';
import './src/scss/black-friday.scss';
import './src/scss/automation.scss';
import IntersectionObserver from '@core/util/intersection-observer';
import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';

import pkg from './package.json';
// import LOGGER from '@component/common/src/util/Logger';
import ObjectUtil from '@component/common/src/util/ObjectUtil';
// import polarisgrids from './src/black-friday.js'
// import vueapp from './src/js/views/vueapp.js'
window.opt = {};
/* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
__webpack_public_path__ = `${pkg.version}/`;
const PageApp = new Marionette.Application();
const PageChannel = PageApp.channel;
import CookieUtil from '@component/common/src/util/Cookie';

window.ishopcookie = CookieUtil.get('ishop_app') || _.filter(window.location.pathname.split('/'), function(obj){ return obj }).pop() == 'app';

try {
  ImpSdk.getDateAndTime(function (a, b, c, d) {
    $('[data-nowtime]').data('nowtime', d);
  })

} catch(e){}

PageApp.brand = "mcom";

PageApp.setMeta = () => {
  try {
    PageApp.meta = JSON.parse($('script[data-bootstrap="page/home-page"]').html()).meta || {};
  } catch (e) {
    PageApp.meta = {};
  }
};


PageApp.getMeta = (key, pa) => {
  if (pa) {
    PageApp.meta = pa;
  }
  var meta = ObjectUtil.getChildProperty(PageApp.meta, key);
  // console.log(PageApp.meta);
  if (_.isUndefined(meta)) {
    return "";
  } else {
    return meta;
  }
};


PageApp.on('start', () => {

  // console.log('starting')
  // try {
  //   // $('head').append('<meta name="format-detection" content="telephone=no"/> <meta name="format-detection" content="date=no"/> <meta name="format-detection" content="address=no"/>');
  //   // console.log('appended', $('meta[name="format-detection"]'));
  //   // var newviewport1 = document.createElement('meta');
  //   // newviewport1.name = 'format-detection';
  //   // newviewport1.content = "telephone=no";
  //   // var newviewport2 = document.createElement('meta');
  //   // newviewport2.name = 'format-detection';
  //   // newviewport2.content = "date=no";
  //   // var newviewport3 = document.createElement('meta');
  //   // newviewport3.name = 'format-detection';
  //   // newviewport3.content = "address=no";
  //   // document.head.appendChild(newviewport1);
  //   // document.head.appendChild(newviewport2);
  //   // document.head.appendChild(newviewport3);
  // } catch(e){
  //   console.log('errr', e)
  // }

  //
  // PageApp.grid = new polarisgrids('document', {
  //   selector: '.product-grid'
  // });
  // PageApp.grid.init();

  // PageApp.Feature = new Example();
  // const newDiv = document.createElement('div');
  // newDiv.setAttribute('class', 'insertedDiv');
  // const newContent = document.createTextNode('Hi there and greetings!');
  // newDiv.appendChild(newContent);
  // const currentDiv = document.getElementsByClassName('example-partial');
  // PageApp.Feature.init();






})


export default PageApp;


// WEBPACK FOOTER //
// /Users/William.Knight/Desktop/macys/campaigns/black-friday/app.js